import { checkPrivilegesForPath } from '../../../config/routePermissions';

// La importación antigua vive en Documentos: sin roles, quien no puede abrir
// esa sección tampoco puede importar desde aquí.
const LEGACY_IMPORT_PATH = '/files';

// La ruta la sirve el manager nuevo, no el router de este: por eso no está en
// Pages.tsx ni se resuelve con getPath().
const USER_IMPORTS_PATH = '/user-imports';

/**
 * El asistente de importación y su historial los sirve el manager nuevo
 * (spec 006), y se llega a ellos desde el menú de Usuarios. No se ofrecen en
 * producción hasta que PRO tenga la ruta `/user-imports`: entonces se quita
 * esta condición.
 *
 * Con los roles encendidos manda el permiso de alta de clientes. Con los roles
 * apagados `can()` siempre es `true`, así que se pide lo mismo que a la
 * importación antigua: el privilegio de Documentos.
 */
export function canOpenUserImports({
    environment,
    rolesEnabled,
    canCreateCustomers,
    privileges,
}: {
    environment: string;
    rolesEnabled: boolean;
    canCreateCustomers: boolean;
    privileges: readonly number[];
}): boolean {
    if (environment === 'PRO') return false;

    return rolesEnabled
        ? canCreateCustomers
        : checkPrivilegesForPath(LEGACY_IMPORT_PATH, privileges);
}

/** Abre el asistente con una carga completa: no es una ruta de este manager. */
export function openUserImportWizard(): void {
    window.location.href = `${USER_IMPORTS_PATH}/new`;
}

/** Abre el historial de importaciones del centro, también en el manager nuevo. */
export function openUserImportHistory(): void {
    window.location.href = USER_IMPORTS_PATH;
}
